export const meetingHasStarted = (session) => {
  const currentTime = Math.floor(new Date().getTime() / 1000)
  const startTime = parseInt(session.epoch_start_time)
  // Open the session 5 minutes prior
  const earlyMeetingTime = startTime - 300
  return currentTime > earlyMeetingTime
}

export const meetingHasEnded = (session) => {
  const currentTime = Math.floor(new Date().getTime() / 1000)
  const endTime = parseInt(session.epoch_end_time)
  // End the session 5 minutes prior
  const earlyEndMeetingTime = endTime - 300
  return currentTime > earlyEndMeetingTime
}

const handleTiming = (session, setNewState) => {
  const currentTime = Math.floor(new Date().getTime() / 1000)
  const startTime = parseInt(session.epoch_start_time)
  const endTime = parseInt(session.epoch_end_time)
  if(!meetingHasStarted(session)) {
    const earlyMeetingTime = startTime - 300
    const timeout = (earlyMeetingTime - currentTime) * 1000
    // 214748 is the largest timeout you can have. 2.5 days
    if(timeout < 2147483647) {
      setTimeout(() => setNewState({ meetingHasStarted: true }), (earlyMeetingTime - currentTime) * 1000, this)
    } else {
      // Reload the page in 24 hours.
      if(!window.reloadTimout) {
        window.reloadTimout = setTimeout(function(){
          window.location.reload()
        },
        86400000)
      }
    }
  }
  if(!meetingHasEnded(session)) {
    const earlyEndMeetingTime = endTime - 300
    const timeout = (earlyEndMeetingTime - currentTime) * 1000
    // 214748 is the largest timeout you can have. 2.5 days
    if(timeout < 2147483647) {
      setTimeout(() => setNewState({ meetingEnded: true }), timeout, this)
    }
  }
}

export default handleTiming